import { render, staticRenderFns } from "./form-field.vue?vue&type=template&id=1c27ab2b&scoped=true&"
import script from "./form-field.vue?vue&type=script&lang=js&"
export * from "./form-field.vue?vue&type=script&lang=js&"
import style0 from "./form-field.vue?vue&type=style&index=0&id=1c27ab2b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27ab2b",
  null
  
)

export default component.exports